export default "__VITE_ASSET__BFHBPtlF__"